const KEY = "attr";

export type Attribution = {
  source: string;
  medium: string | null;
  campaign: string | null;
  content: string | null;
  referrer: string | null;
  landedAt: string;
};

const SOURCES: Record<string, string> = {
  tt: "tiktok",
  ig: "instagram",
  yt: "youtube",
};

// Call once at app startup. First touch only: never overwrites.
export function captureAttribution() {
  try {
    if (localStorage.getItem(KEY)) return;
    const p = new URLSearchParams(window.location.search);

    let source = p.get("utm_source");
    let medium = p.get("utm_medium");
    let campaign = p.get("utm_campaign");
    const content = p.get("utm_content");

    // Short form: ?r=tt_rio95956
    const r = p.get("r");
    if (!source && r) {
      const i = r.indexOf("_");
      const prefix = i > 0 ? r.slice(0, i) : "";
      if (SOURCES[prefix]) {
        source = SOURCES[prefix];
        campaign = r.slice(i + 1);
      } else {
        source = "ref";
        campaign = r;
      }
      medium = "bio";
    }

    if (!source) return;

    const data: Attribution = {
      source,
      medium,
      campaign,
      content,
      referrer: document.referrer || null,
      landedAt: new Date().toISOString(),
    };
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch {}
}

export function getAttribution(): Attribution | null {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
}

function toBase64Url(s: string) {
  const bytes = new TextEncoder().encode(s);
  let bin = "";
  bytes.forEach((b) => (bin += String.fromCharCode(b)));
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

// Use for the "Continue with Google" buttons
export function googleAuthUrl(apiUrl: string, heardFrom?: string) {
  const payload = toBase64Url(
    JSON.stringify({ attribution: getAttribution(), heardFrom: heardFrom || undefined })
  );
  return `${apiUrl}/api/auth/google?attr=${payload}`;
}